import { CSSProperties } from '@mui/material/styles/createTypography';
import { Box, ThemeProvider } from '@mui/system';
import { Container } from '@mui/material';
import theme from '../../src/style-system/theme';
import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import Image from 'next/image';

import { animationduration } from '@utils/data';

interface CarouselProps {
  carouselContent: any;
}

const ImageCarousel = ({ carouselContent }: CarouselProps) => {
  const indicatorStyles: CSSProperties = {
    background: 'transparent',
    width: 10,
    height: 10,
    display: 'inline-block',
    margin: '0 8px',
    borderRadius: '50%',
    border: `1px solid ${theme.palette.cinnamon.main}`,
    cursor: 'pointer',
  };

  return (
    <Container
      maxWidth="xl"
      disableGutters
      sx={{
        '& .carousel.carousel-slider': {
          display: 'flex',
          flexDirection: 'column',
        },
        '& .carousel .slider-wrapper': {
          order: 1,
        },
        '& .carousel .control-dots': {
          position: 'relative',
          bottom: 'auto',
          order: 2,
          marginTop: '8px',
          marginBottom: '12px',
        },
      }}
    >
      <Carousel
        autoPlay
        infiniteLoop
        interval={animationduration}
        showStatus={false}
        showThumbs={false}
        showArrows={false}
        renderIndicator={(onClickHandler, isSelected, index, label) => {
          if (isSelected) {
            return (
              <li
                style={{
                  ...indicatorStyles,
                  background: theme.palette.cinnamon.main,
                }}
                aria-label={`Selected: ${label} ${index + 1}`}
                title={`Selected: ${label} ${index + 1}`}
              />
            );
          }
          return (
            <li
              style={indicatorStyles}
              onClick={onClickHandler}
              onKeyDown={onClickHandler}
              value={index}
              key={index}
              role="button"
              tabIndex={0}
              title={`${label} ${index + 1}`}
              aria-label={`${label} ${index + 1}`}
            />
          );
        }}
      >
        {carouselContent.map((item: any, index: number) => {
          return (
            <Box
              key={index}
              sx={{
                //marginTop: '15px',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <Box
                sx={{
                  position: 'relative',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  width: '100%',
                  height: '300px',
                  [theme.breakpoints.up('md')]: {
                    //width: '250px',
                    height: '340px',
                  },
                }}
              >
                <Image
                  src={item}
                  alt={item}
                  objectFit="contain"
                  layout="fill"
                />
              </Box>
            </Box>
          );
        })}
      </Carousel>
    </Container>
  );
};

export default ImageCarousel;
